// Core
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// Store
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/index';
import Loading from './layout/elements/Loading';

// Components
import './i18n/i18n';

// Services
import * as serviceWorker from './serviceWorker';

// The app
import App from './App';

// Rendering
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<Loading className="mv4" />} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);

// After services
serviceWorker.unregister();
